//ALT-ORDER SYSTEM
//Unified system for multiple order modes (preorder, exChina, etc.)
//Based conservatively on preorder.js
//
// NOTE: Global variables (cartMode, previousCartMode, MODES_CONFIG) are now loaded from theme.liquid

$(document).ready(function () {
    if (window.collectionExportDownloadOnly) return;
    // cartMode is already initialized in theme.liquid
    // Initialize alt-order functionality
    initAltOrderToggle();
  
    // Set up alt-order cart handlers
    setupAltOrderCartHandlers();
  
    // Initialize alt-order cart count display
    updateAltOrderCartIcon();
  
    // Check if we need to redirect based on current page and alt-order state
    handleCartRedirection();
  
    // Listen for infinite scroll events
    setupInfiniteScrollListener();
    
    // Check and show first-visit alert for active modes
    showFirstVisitAlert();
  });
  
  function changeCollectionLinks(){
    if(Shopify.designMode) return;
  
    const config = MODES_CONFIG[cartMode];
    // Optimization: Skip if mode has no tags (e.g. visitor)
    if (!config || !config.tags || !config.tags.length) return;

    const PARAM = 'filter.p.tag';
    const MODE_TAGS = config ? config.tags : [];
  
    document.addEventListener('click', e => {
      const a = e.target.closest('a[href*="/collections/"]');
      if(!a) return;
      e.preventDefault();
  
      const url = new URL(a.href, location.origin);
      const params = url.searchParams;
      let tags = (params.get(PARAM) || '').split(',').filter(Boolean);
  
      if(cartMode && config){ // If we have an active mode
        // Only apply tags if the current mode requires tag filtering
        const shouldApplyTags = 
          (cartMode === 'preorder' && window.altOrderSettings?.preorderOnlyWithTag) ||
          (cartMode === 'exChina' && window.altOrderSettings?.exChinaOnlyWithTag);
        
        if (shouldApplyTags) {
          MODE_TAGS.forEach(t => { if(!tags.includes(t)) tags.push(t); });
        } else {
          // Remove all alt-order tags if mode doesn't require filtering
          Object.values(MODES_CONFIG).forEach(modeConfig => {
            tags = tags.filter(t => !modeConfig.tags.includes(t));
          });
        }
      } else { // Normal mode - remove all alt-order tags
        Object.values(MODES_CONFIG).forEach(modeConfig => {
          tags = tags.filter(t => !modeConfig.tags.includes(t));
        });
      }
  
      tags.length ? params.set(PARAM, tags.join(',')) : params.delete(PARAM);
  
      const query = [...params.entries()]
        .map(([k,v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v).replace(/%2C/g,',')}`)
        .join('&');
  
      location.assign(url.origin + url.pathname + (query ? '?' + query : '') + url.hash);
    }, true);
  }
  
  
  
  function setupInfiniteScrollListener() {
    // Listen for when new products are loaded via infinite scroll
    document.addEventListener('infiniteScrollComplete', function (e) {
      // Update prices for newly loaded products
      updateNewlyLoadedPrices();
  
      // Update quantity inputs and sold-out elements for newly loaded products
      updateNewlyLoadedElements();
    });
  }
  
  function updateNewlyLoadedPrices(){
    const config = MODES_CONFIG[cartMode];
    
    // If mode uses original prices, do nothing
    if (config && config.useOriginalPrices) return;

    // Handle general price changes (both preorder and exChina)
    if (config && config.priceDataAttr) {
      $(`span[${config.priceDataAttr}]:not([data-price])`).each(function(){ 
        const $el = $(this);
        $el.attr('data-price', $el.text());            // save original
        const newP = $el.attr(config.priceDataAttr);
        if(newP) $el.text(newP);                       // show mode-specific price
      });
    }
  
    // Handle B2C prices (only for preorder mode)
    if (cartMode === 'preorder' && config && config.b2cPriceDataAttr) {
      $(`span.b2c-price[${config.b2cPriceDataAttr}]:not([data-b2c-price])`).each(function(){
        const $el = $(this);
        $el.attr('data-b2c-price', $el.text());        // save original
        const newP = $el.attr(config.b2cPriceDataAttr);
        if(newP) $el.text(newP);                       // swap if needed
      });
    }
  }
  
  
  function updateNewlyLoadedElements() {
    const config = MODES_CONFIG[cartMode];

    if (cartMode) { // If we have an active alt-order mode (preorder or exChina)
      
      // If mode respects stock (visitor), do nothing or restore limits if needed
      // Actually, alt-order logic usually REMOVES limits. If we respect stock, we just don't run the removal code.
      if (config && config.respectStock) {
          return;
      }

      // Enable inputs and remove max limits
      $('input[type="number"][max]:not([data-altorder-processed])').each(function () {
        const $input = $(this);
        // Store original max
        $input.attr('data-original-max', $input.attr('max'));
        $input.attr('data-altorder-processed', 'true');
        // Remove max attribute
        $input.removeAttr('max');
      });
  
      // Enable disabled inputs
      $('.product-variant-container input[disabled]:not([data-altorder-processed])').each(function () {
        const $input = $(this);
        $input.attr('data-altorder-processed', 'true');
        $input.removeAttr('disabled');
      });
  
  
    } else {
      // Restore max attributes
      $('input[type="number"][data-original-max]:not([data-altorder-processed])').each(function () {
        const $input = $(this);
        $input.attr('data-altorder-processed', 'true');
        $input.attr('max', $input.attr('data-original-max'));
      });
  
      // Re-disable inputs in sold-out variants
      $('.product-variant-container.sold-out input:not([data-altorder-processed])').each(function () {
        const $input = $(this);
        $input.attr('data-altorder-processed', 'true');
        $input.attr('disabled', 'disabled');
      });
    }
  }
  
  function updateAllPrices() {
    const config = MODES_CONFIG[cartMode];
    const isActive = !!cartMode; // True if any mode is active
    
    // Always target general price spans, regardless of mode
    $('span.price-item').each(function () {
      const $this = $(this);

      // On first run, cache the original price
      if (!$this.attr('data-original-price')) {
        $this.attr('data-original-price', $this.text());
      }
      
      const originalPrice = $this.attr('data-original-price');
      
      // Update price based on mode
      if (isActive && config && config.priceDataAttr) {
        const newPrice = $this.attr(config.priceDataAttr);
        if (newPrice) $this.text(newPrice);
      } else {
        $this.text(originalPrice);
      }
    });
    
    // Handle B2C prices (only for preorder mode)
    if (cartMode === 'preorder' && config && config.b2cPriceDataAttr) {
      $('span.b2c-price').each(function () {
        const $this = $(this);
        const price = $this.attr('data-b2c-price') || $this.text();
        const newPrice = $this.attr(config.b2cPriceDataAttr);
        if (price != newPrice) {
          if (isActive) {
            $this.attr('data-b2c-price', price);
            $this.text(newPrice);
          } else {
            if (price) {
              $this.text(price);
            }
          }
        }
      });
    } else if (cartMode !== 'preorder') {
      // Restore original B2C prices when not in preorder mode
      $('span.b2c-price').each(function () {
        const $this = $(this);
        const originalB2CPrice = $this.attr('data-b2c-price');
        if (originalB2CPrice) {
          $this.text(originalB2CPrice);
        }
      });
    }
  }
  
  function initAltOrderToggle() {
    if (cartMode === 'visitor') {
      updateAltOrderState("load");
      return;
    }

    // Use unified radio selector for cart modes
    const $cartModeRadios = $('input[name="cart-mode"]');
    if (!$cartModeRadios.length) return;
  
    // Set initial state from cartMode
    if (cartMode) {
      $(`input[name="cart-mode"][value="${cartMode}"]`).prop('checked', true);
    } else {
      $('input[name="cart-mode"][value=""]').prop('checked', true);
    }
    updateAltOrderState("load");
  
    // Add event listener for radio changes
    $cartModeRadios.on('change', function () {
      if ($(this).is(':checked')) {
        const selectedMode = $(this).val();
        
        // Reset quantity inputs and all selection states in collections when changing modes
        if (window.location.pathname.includes('/collections') || window.location.pathname.includes('/search')) {
          // Reset quantity inputs to 0
          $('.quantity__input').val(0);
          
          // Reset previousValue data to ensure fresh calculations
          $('.quantity__input').removeData('previousValue');
          
          // Remove selected-item class from all quantity inputs
          $('.quantity__input').removeClass('selected-item');
          
          // Remove selected-product class from all grid items
          $('.grid__item').removeClass('selected-product');
          
          // Reset product quantity data on grid items
          $('.grid__item').removeData('quantity');

          // Reset totalQuantity if it exists (from collection.js)
          if (typeof totalQuantity !== 'undefined') {
            totalQuantity = 0;
            $('#qty_to_add').text(0);
            $('#qty_to_altorder').text(0);
            $('.bulkadd_container').slideUp('fast');
          }
        }  
        
        // Update global cartMode
        // Store previous mode before changing (session variable, resets on page load)
        previousCartMode = cartMode;
        cartMode = selectedMode;
        localStorage.setItem('cartMode', cartMode);
        
        updateAltOrderState("change");
    
        // Handle cart redirection when mode changes
        handleCartRedirection();
      }
    });
  }
  
  async function updateAltOrderState(from) {
    const config = MODES_CONFIG[cartMode];
    const isActive = !!cartMode; // True if any mode is active
    changeCollectionLinks();
    
    // Clear all mode data attributes from body first
    Object.values(MODES_CONFIG).forEach(modeConfig => {
      $('body').removeAttr(modeConfig.bodyDataAttr);
    });
    
    // Add data attribute to body for current mode
    if (config) {
      $('body').attr(config.bodyDataAttr, 'true');
    }
  
    // Reset data-altorder-processed attributes to allow re-processing after state change
    $('[data-altorder-processed]').removeAttr('data-altorder-processed');
  
    // Toggle functionality based on mode state
    if (isActive) {
      // Check if we should respect stock limits (visitor mode)
      if (!config || !config.respectStock) {
        // Product page buttons - using more specific selectors
        if (window.location.pathname.includes('/products')) {
          enableAltOrderQuantities('product');
        }
    
        // Collection and search page elements
        if (window.location.pathname.includes('/collections') || window.location.pathname.includes('/search')) {
          enableAltOrderQuantities('collection');
          // Always clean previous tags first, then add new ones if filtering is enabled
          await cleanAndApplyAltOrderTags();
        }
      } else {
        // For visitor mode or modes that respect stock, we might still need to handle tags
        if (window.location.pathname.includes('/collections') || window.location.pathname.includes('/search')) {
           await cleanAndApplyAltOrderTags();
        }
      }
    } else {
      // Product page buttons - using more specific selectors
      if (window.location.pathname.includes('/products')) {
        restoreQuantityLimitations('product');
      } else if (window.location.pathname.includes('/collections') || window.location.pathname.includes('/search')) {
        restoreQuantityLimitations('collection');
        removeAltOrderTags();
      }
    }

    // Update all prices based on mode state
    // Skip price update if we're in collection/search and filters will be applied/removed
    // (prices will be updated after facet reload in facets.js)
    const isCollectionPage = window.location.pathname.includes('/collections') || window.location.pathname.includes('/search');
    const willApplyFilters = isActive && isCollectionPage && 
      ((cartMode === 'preorder' && window.altOrderSettings?.preorderOnlyWithTag) || 
       (cartMode === 'exChina' && window.altOrderSettings?.exChinaOnlyWithTag));
    
    // Also skip if we're switching from a mode that had filters (they will be removed)
    const switchingFromFilteredMode = isCollectionPage && 
      ((previousCartMode === 'preorder' && window.altOrderSettings?.preorderOnlyWithTag) ||
       (previousCartMode === 'exChina' && window.altOrderSettings?.exChinaOnlyWithTag));
    const willRemoveFilters = isActive && switchingFromFilteredMode;
    
    
    if ((!willApplyFilters && !willRemoveFilters) || from === "load") {
      if (!config || !config.useOriginalPrices) {
        updateAllPrices();
      }
    } 
    
    // Update bulk button text for collections
    updateBulkButtonText();
    
    // Update alt-order button text for product pages
    updateAltOrderButtonText();
    
    // Update preorder cart icon display
    updateAltOrderCartIcon();
    
    // Refresh secondary cart if we're on that page
    if (typeof fetchSecondaryCartItemDetails === 'function' && document.getElementById('secondary-cart-container')) {
      fetchSecondaryCartItemDetails();
    }
  
    // Dispatch a custom event that other scripts can listen for
    $(document).trigger('altOrderStateChanged', { 
      cartMode: cartMode,
      isActive: !!cartMode,
    });

    document.documentElement.classList.remove('alt-order-initializing');
  }
  
  function updateAltOrderButtonText() {
    const config = MODES_CONFIG[cartMode];
    const buttonText = document.getElementById('alt-order-button-text');
    const button = document.getElementById('alt-order-button');
    
    if (!buttonText || !button) return; // Elements not found
    
    if (config && cartMode) {
      // Show button with mode-specific text
      buttonText.textContent = config.buttonText;
      button.style.display = 'block';
    } else {
      // Hide button when no mode is active
      button.style.display = 'none';
    }
  }
  
  function updateBulkButtonText() {
    const config = MODES_CONFIG[cartMode];
    const bulkButton = document.getElementById('button_bulk_altorder');
    
    if (!bulkButton) return; // Element not found
    
    if (config && cartMode) {
      // Update bulk button text with mode-specific text
      const template = config.bulkButtonText;
      const currentQty = document.getElementById('qty_to_altorder');
      const qtyText = currentQty ? currentQty.textContent : '0';
      
      // Replace {qty} placeholder with actual quantity
      const buttonText = template.replace('{qty}', `<span id="qty_to_altorder">${qtyText}</span>`);
      bulkButton.innerHTML = buttonText;
    }
  }
  
  function enableAltOrderQuantities(from = 'collection') {
    // Find all quantity inputs with variant-outofstock class and handle them
    $('.variant-outofstock').each(function () {
      const $input = $(this);
  
      // Store the original class in a data attribute for later restoration
      $input.attr('data-original-class', 'variant-outofstock');
  
      // Remove the outofstock class and add alt-order class
      $input.removeClass('variant-outofstock').addClass('alt-order-variant');
    });
  
    // Find all quantity inputs with max attribute and handle them
    $('input[type="number"][max]').each(function () {
      const $input = $(this);
      const maxValue = $input.attr('max');
  
      // Store the original max value in a data attribute for later restoration
      $input.attr('data-original-max', maxValue);
  
      // Remove the max attribute to allow any quantity
      $input.attr('max', "999999");
    });
  
    // Enable all disabled inputs in product variant containers
    $('.product-variant-container input[disabled]').removeAttr('disabled');
  }
  
  
  function restoreQuantityLimitations(from = 'collection') {
    // Restore variant-outofstock class
    $('.alt-order-variant').each(function () {
      const $input = $(this);
      const originalClass = $input.attr('data-original-class');
  
      if (originalClass) {
        $input.removeClass('alt-order-variant').addClass(originalClass);
        $input.removeAttr('data-original-class');
      }
    });
  
    // Restore max attribute
    $('input[type="number"][data-original-max]').each(function () {
      const $input = $(this);
      const originalMax = $input.attr('data-original-max');
  
      if (originalMax) {
        $input.attr('max', originalMax);
        $input.removeAttr('data-original-max');
      }
    });
  
    // Re-disable inputs in sold out variants
    $('.product-variant-container.sold-out input').attr('disabled', 'disabled');
  }
  
  function initAltOrderCart() {
    const config = MODES_CONFIG[cartMode];
    if (!config) return; // No active mode
    
    const cartKey = config.cartKey;
    if (!localStorage.getItem(cartKey)) {
      localStorage.setItem(cartKey, JSON.stringify({}));
    }
  }

  /** Match product-image-downloads.js (collection pages omit that script — keep in sync manually). */
  function altOrderNormalizeUrlEntry(entry) {
    if (typeof entry === 'string') return entry.trim();
    if (!entry || typeof entry !== 'object') return '';
    var keys = ['url', 'src', 'href', 'link', 'path'];
    for (var ki = 0; ki < keys.length; ki++) {
      var k = keys[ki];
      if (typeof entry[k] === 'string' && entry[k].trim()) return entry[k].trim();
    }
    return '';
  }

  function altOrderFlattenImageList(raw) {
    if (raw == null || raw === '') return [];
    if (Array.isArray(raw)) {
      return raw.map(altOrderNormalizeUrlEntry).filter(Boolean);
    }
    if (typeof raw === 'string') {
      var t = raw.trim();
      if (!t) return [];
      var c0 = t.charAt(0);
      if (c0 === '[' || c0 === '{') {
        try {
          return altOrderFlattenImageList(JSON.parse(t));
        } catch (parseErr) {
          return [altOrderNormalizeUrlEntry(t)].filter(Boolean);
        }
      }
      if (t.indexOf(',') !== -1 && (t.indexOf('http') !== -1 || t.indexOf('/') !== -1)) {
        return t.split(',').map(function (part) {
          return altOrderNormalizeUrlEntry(part.trim());
        }).filter(Boolean);
      }
      return [altOrderNormalizeUrlEntry(t)].filter(Boolean);
    }
    if (typeof raw === 'object') {
      var single = altOrderNormalizeUrlEntry(raw);
      if (single) return [single];
      var acc = [];
      Object.keys(raw).forEach(function (rk) {
        acc = acc.concat(altOrderFlattenImageList(raw[rk]));
      });
      return acc;
    }
    return [];
  }

  function altOrderNormalizeImages(raw) {
    if (
      window.ProductImageDownloads &&
      typeof window.ProductImageDownloads.normalizeImages === 'function'
    ) {
      try {
        return window.ProductImageDownloads.normalizeImages(raw);
      } catch (reuseErr) {
        // Fallback below when normalizeImages rejects shape in edge cases.
      }
    }

    var source = raw;
    if (source == null || source === '')
      return { views: [], actions: [] };

    if (typeof source === 'string') {
      try {
        source = JSON.parse(source.trim());
      } catch (e) {
        return { views: [], actions: [] };
      }
    }

    if (Array.isArray(source)) {
      return { views: altOrderFlattenImageList(source), actions: [] };
    }
    if (typeof source !== 'object')
      return { views: [], actions: [] };

    var views = [];
    var actions = [];

    Object.keys(source).forEach(function (key) {
      var nk = key.toLowerCase();
      var isView = nk === 'view' || nk === 'views';
      var isAct = nk === 'action' || nk === 'actions';

      if (!isView && !isAct) return;

      var flat = altOrderFlattenImageList(source[key]);

      if (isView) views = views.concat(flat);
      else actions = actions.concat(flat);
    });

    return { views: views, actions: actions };
  }
  
  function getProductDownloadImageData($scope, context) {
    const selector = context ? `.product-image-download-data[data-download-context="${context}"]` : '.product-image-download-data';
    const script = ($scope && $scope.length ? $scope.find(selector).first()[0] : document.querySelector(selector));

    if (!script) {
      return {
        images: { views: [], actions: [] },
        reference: '',
        sizeChartUrl: ''
      };
    }

    try {
      const data = JSON.parse(script.textContent);
      let rawImg = data.images || {};
      if (typeof rawImg === 'string') {
        try {
          rawImg = JSON.parse(rawImg.trim());
        } catch (parseImgErr) {
          rawImg = {};
        }
      }

      const images = altOrderNormalizeImages(rawImg);
      var sizeChartUrl = '';
      if (data.sizeChartUrl && String(data.sizeChartUrl).trim()) {
        sizeChartUrl = String(data.sizeChartUrl)
          .trim()
          .replace(/^http:\/\//i, 'https://');
      }

      return {
        images,
        reference: data.reference || '',
        sizeChartUrl: sizeChartUrl
      };
    } catch (error) {
      console.error('Invalid product image download JSON:', error);
      return {
        images: { views: [], actions: [] },
        reference: '',
        sizeChartUrl: ''
      };
    }
  }

  function readExchinaMetafieldsFromDOM($scope) {
    if (cartMode !== 'exChina' || !$scope || !$scope.length) return null;
    const root = $scope.find('.exchina-metafield-badges-root')[0];
    if (!root) return null;
    const ds = root.dataset || {};
    const deadlineTier = (ds.exchinaOrderDeadlineTier || '').trim();
    const deadlineRaw = (ds.exchinaOrderDeadlineRaw || '').trim();
    const readyTier = (ds.exchinaApproxReadyTier || '').trim();
    const readyRaw = (ds.exchinaApproxReadyRaw || '').trim();
    const extraInfo = (ds.exchinaExtraInfo || '').trim();

    if (!(deadlineTier || readyTier || extraInfo)) return null;

    const out = {};
    if (deadlineTier) {
      out.orderDeadlineTier = deadlineTier;
      out.orderDeadlineRaw = deadlineRaw || null;
      out.orderDeadlineLabel = ('DEADLINE IN ' + (deadlineRaw || '')).trim();
    }
    if (readyTier) {
      out.approxReadyTier = readyTier;
      out.approxReadyRaw = readyRaw || null;
      out.approxReadyLabel = ('READY IN ' + (readyRaw || '')).trim();
    }
    if (extraInfo) out.extraInfo = extraInfo;
    if (!(out.orderDeadlineTier || out.approxReadyTier || out.extraInfo)) return null;
    return out;
  }

  function addToAltOrderCart(sku, title, variantId, quantity, showNotification = true) {
    // Validate input
    if (!variantId) {
      return;
    }
  
    // Ensure quantity is a valid number
    quantity = isNaN(quantity) ? 1 : Number(quantity);
  
    if (quantity <= 0) {
      return;
    }
  
    initAltOrderCart();
  
    // Get the current page type to determine where to get product information from
    const isProductPage = window.location.pathname.includes('/products/');
  
    // Collect product information based on page type
    let productInfo = {};
    let variantInfo = {};
    let exChinaDomScope = null;

    if (isProductPage) {
      const downloadImageData = getProductDownloadImageData(null, 'product');
      // Get information from product page
      productInfo = {
        title: $('.product__title h1').text().trim(),
        handle: window.location.pathname.split('/').pop().split('?')[0],
        mainImage: $('.product__media img').first().attr('src').split('?')[0],
        reference: downloadImageData.reference,
        downloadImages: downloadImageData.images,
        sizeChartUrl: downloadImageData.sizeChartUrl || ''
      };
  
      // Get variant information with mode-specific price
      const config = MODES_CONFIG[cartMode];
      let priceValue = config && config.priceCentsDataAttr ? 
        $('.price-item').data(config.priceCentsDataAttr.replace('data-', '').replace('-', '_')) : 
        $('.price-item').data('new_price_cents');

        variantInfo = {
        sku: sku,
        shopifyId: variantId,
        quantity: quantity,
        price: priceValue,
        title: title,
        maxQuantity: $(`.quantity__input[data-id="${variantId}"]`).attr('max') || null
      };

      exChinaDomScope = $('.product').first();
  
    } else {
      // Get information from collection page or modal
      const $variantContainer = $(`[data-id="${variantId}"]`).closest('.product-variant-container');
      const $productCard = $variantContainer.closest('.card-wrapper');
  
      if ($productCard.length) {
        const $productLink = $productCard.find('.product-link');
        const handle = $productLink.attr('href').split('/').pop().split('?')[0];
        const downloadImageData = getProductDownloadImageData($productCard, 'card');
  
        productInfo = {
          title: $productCard.find('.product-title').text().trim(),
          handle: handle,
          mainImage: $productCard.find('.card__media img').attr('src').split('?')[0],
          reference: downloadImageData.reference,
          downloadImages: downloadImageData.images,
          sizeChartUrl: downloadImageData.sizeChartUrl || ''
        };
  
        // Get variant information with mode-specific price
        const config = MODES_CONFIG[cartMode];
        let priceValue = config && config.priceCentsDataAttr ? 
          $productCard.find('.price-item').data(config.priceCentsDataAttr.replace('data-', '').replace('-', '_')) : 
          $productCard.find('.price-item').data('new_price_cents');

        variantInfo = {
          sku: sku,
          shopifyId: variantId,
          quantity: quantity,
          price: priceValue,
          title: $variantContainer.find('.variant-title').text().trim(),
          maxQuantity: $variantContainer.find('.quantity__input').attr('max') || null
        };

        exChinaDomScope = $productCard;

      } else {
        // If we can't find all the info, just skip adding to cart
        console.warn('Could not find complete product information for variant:', variantId);
        return;
      }
    }

    const exchinaMeta =
      cartMode === 'exChina' ? readExchinaMetafieldsFromDOM(exChinaDomScope) : null;

    // Get current cart using dynamic cart key
    const config = MODES_CONFIG[cartMode];
    if (!config) return; // No active mode
    
    const cartKey = config.cartKey;
    const altCart = JSON.parse(localStorage.getItem(cartKey) || '{}');
  
    // Create product entry if it doesn't exist
    if (!altCart[productInfo.handle]) {
      altCart[productInfo.handle] = {
        title: productInfo.title,
        mainImage: productInfo.mainImage,
        reference: productInfo.reference,
        downloadImages: productInfo.downloadImages,
        sizeChartUrl: productInfo.sizeChartUrl || '',
        items: []
      };
    } else {
      if (!altCart[productInfo.handle].downloadImages && productInfo.downloadImages) {
        altCart[productInfo.handle].reference = productInfo.reference;
        altCart[productInfo.handle].downloadImages = productInfo.downloadImages;
      }
      if (
        productInfo.sizeChartUrl &&
        !altCart[productInfo.handle].sizeChartUrl
      ) {
        altCart[productInfo.handle].sizeChartUrl = productInfo.sizeChartUrl;
      }
    }

    if (cartMode === 'exChina') {
      if (exchinaMeta) {
        altCart[productInfo.handle].exchinaMeta = exchinaMeta;
      } else if (altCart[productInfo.handle].exchinaMeta) {
        delete altCart[productInfo.handle].exchinaMeta;
      }
    }

    // Check if the variant already exists in the product's items
    const existingItemIndex = altCart[productInfo.handle].items.findIndex(
      item => item.shopifyId === variantId
    );
  
    if (existingItemIndex >= 0) {
      // Update quantity if item already exists
      altCart[productInfo.handle].items[existingItemIndex].quantity += quantity;
    } else {
      // Add new item to cart
      altCart[productInfo.handle].items.push(variantInfo);
      //sort items by shopifyId
      altCart[productInfo.handle].items.sort((a, b) => a.shopifyId - b.shopifyId);
    }
  
    // Save updated cart back to localStorage
    localStorage.setItem(cartKey, JSON.stringify(altCart));
  
    // Dispatch event to notify UI that alt-order cart has been updated
    $(document).trigger('altOrderCartUpdated', { count: getAltOrderCartCount() });
  
    // Update alt-order cart icon
    updateAltOrderCartIcon();
  
    // Show confirmation message only if requested
    if (showNotification) {
      showAltOrderConfirmation(quantity);
    }
  }
  
  function getAltOrderCartCount() {
    const config = MODES_CONFIG[cartMode];
    if (!config) return 0; // No active mode
    
    const cartKey = config.cartKey;
    const altCart = JSON.parse(localStorage.getItem(cartKey) || '{}');
    let count = 0;

    // Loop through each product handle
    Object.keys(altCart).forEach(handle => {
      // Loop through each variant in the product
      altCart[handle].items.forEach(item => {
        count += item.quantity;
      });
    });

    // Include Skates on Demand pack totals for the active eligible mode
    if (window.Sod && typeof window.Sod.isSodEligibleMode === 'function' && window.Sod.isSodEligibleMode(cartMode) && typeof window.Sod.getSodCount === 'function') {
      count += window.Sod.getSodCount();
    }

    return count;
  }
  
  function showAltOrderConfirmation(quantity, itemCount = 1) {
    // Get alt-order notification element
    const notification = document.getElementById('alt-order-notification');
    if (!notification) return;
  
    // Find the message element using the correct ID from the HTML
    const messageElement = document.getElementById('alt-order-notification-message');
    if (!messageElement) return;
  
    // Get mode name for dynamic messaging
    const config = MODES_CONFIG[cartMode];
    const modeName = config ? config.name.toLowerCase() : 'alt-order';

    // Customize message based on quantity and item count
    if (quantity === 0) {
      messageElement.textContent = `No items added to ${modeName}`;
    } else if (itemCount === 1) {
      messageElement.textContent = `${quantity} item(s) added to ${modeName}`;
    } else {
      messageElement.textContent = `${quantity} items from ${itemCount} variants added to ${modeName}`;
    }
  
    // Use the same animation pattern as cart-notification
    notification.classList.add('animate', 'active');
  
    // Auto-close after 3 seconds
    setTimeout(() => {
      notification.classList.remove('active');
  
      // Wait for animation to complete before removing animate class
      setTimeout(() => {
        notification.classList.remove('animate');
      }, 500);
    }, 3000);
  }
  
  function setupAltOrderCartHandlers() {
    // Initialize alt-order cart
    initAltOrderCart();
  
    // Handle the preorder button click - use a more specific selector
    $(document).on('click', 'button[data-alt-cart]', function (e) {
      e.preventDefault();
  
      // Collect all variant quantities from the form
      const variantsToAdd = [];
      let totalQuantity = 0;
  
      // Get all quantity inputs in the variantQuantity divs
      $('.quantity__input').each(function () {
        const $input = $(this);
        const quantityVal = parseInt($input.val() || '0');
  
        // Only add variants with quantity > 0
        if (quantityVal > 0) {
          // Extract the variant ID from the input ID (format: "Quantity-VARIANTID")
          const variantId = parseInt($input.data('id'));
          const sku = $input.data('sku');
  
          if (variantId) {
            variantsToAdd.push({
              sku: sku,
              variantId: variantId,
              title: $input.data('title') || 'Default',
              quantity: quantityVal
            });
            totalQuantity += quantityVal;
          }
        }
      });
  
      // Handle the case when no variants are selected
      if (variantsToAdd.length === 0) {
        alert('Please select at least one variant with quantity greater than 0.');
        return;
      }
      for (const item of variantsToAdd) {
        addToAltOrderCart(item.sku, item.title, item.variantId, item.quantity, false); // Don't show notification for each item
      }
  
      // Show a single notification for all items
      showAltOrderConfirmation(totalQuantity, variantsToAdd.length);
  
      // Reset all quantity inputs to 0
      $('.variantQuantity .quantity__input').val(0);
  
    });
  
    // Update cart count indicator if it exists
    updateAltOrderCartCountDisplay();
  
    // Listen for cart updates
    $(document).on('altOrderCartUpdated', function () {
      updateAltOrderCartCountDisplay();
    });
  
    // Add bulk add to alt-order functionality
    $(document).on('click', '#button_bulk_altorder', function (e) {
      e.preventDefault();
      bulkAddToAltOrder();
    });
  }
  
  function bulkAddToAltOrder() {
    // Get all quantity inputs for this product
    const quantityInputs = document.querySelectorAll(`.product-variant-container input[type="number"]`);
  
    let totalQuantity = 0;
    const variantsToAdd = [];
  
    // Collect all variants with quantities > 0
    quantityInputs.forEach(input => {
      const quantity = parseInt(input.value || '0');
  
      if (quantity > 0) {
        variantsToAdd.push({
          sku: input.getAttribute('data-sku'),
          variantId: parseInt(input.getAttribute('data-id')),
          quantity: quantity,
          title: input.getAttribute('data-title') || 'Default'
        });
        totalQuantity += quantity;
      }
    });
  
    // Check if we have any variants to add
    if (variantsToAdd.length === 0) {
      alert('Please select at least one variant with quantity greater than 0.');
      return;
    }
  
    // Add all variants to the alt-order cart
    variantsToAdd.forEach(item => {
      addToAltOrderCart(item.sku, item.title, item.variantId, item.quantity, false);
    });
  
    // Show a single notification for all items
    showAltOrderConfirmation(totalQuantity, variantsToAdd.length);
  
    // Reset all quantity inputs to 0
    quantityInputs.forEach(input => {
      input.value = 0;
    });
  
    // Ocultar el contenedor de bulk add
    $('.bulkadd_container').slideToggle();
  
    // Deseleccionar todas las tarjetas de productos
    $('.selected-product').removeClass('selected-product');
  }
  
  function updateAltOrderCartIcon() {
    const count = getAltOrderCartCount();
    const altOrderCartIcon = document.getElementById('alt-order-cart-icon-bubble');
    const altOrderCartCount = document.querySelector('.alt-order-cart-count span:first-child');
  
    if (!altOrderCartIcon || !altOrderCartCount) return;
  
    // Update count text
    altOrderCartCount.textContent = count;
  
  }
  
  function updateAltOrderCartCountDisplay() {
    const count = getAltOrderCartCount();
    $('.alt-order-cart-count span:first-child').text(count);
    updateAltOrderCartIcon();
  }
  
  function handleCartRedirection() {
    // Get current page path
    const currentPath = window.location.pathname;
    const isAltOrderMode = !!cartMode; // True if any alt-order mode is active

    // Check if we're on a cart page and need to redirect
    if (currentPath === '/cart' && isAltOrderMode) {
      // We're on regular cart but in alt-order mode, redirect to alt cart
      window.location.href = '/pages/secondary-cart';
    } else if (currentPath === '/pages/secondary-cart' && !isAltOrderMode) {
      // We're on alt cart but in regular mode, redirect to regular cart
      window.location.href = '/cart';
    }
  }
  
  
  /* ---------- SHARED ---------- */
  
  /* wait until the custom element exists and then returns it */
  function getFacetsClass() {
    return customElements.whenDefined('facet-filters-form')
      .then(() => customElements.get('facet-filters-form'));
  }
  
  
  /* ---------- REMOVE ONLY alt-order tags ---------- */
  async function removeAltOrderTags() {
    // Check if tag filtering is enabled for any mode
    const settings = window.altOrderSettings || {};
    const shouldFilterTags = settings.preorderOnlyWithTag || settings.exChinaOnlyWithTag;
    
    if (!shouldFilterTags) return; // Tag filtering disabled, no need to remove tags
    
    const Facets = await getFacetsClass();
  
    const params  = new URLSearchParams(window.location.search);

    if (
      window.location.pathname.includes('/search') &&
      typeof window.applyAltOrderSearchConstraint === 'function'
    ) {
      const currentParams = params.toString().replace(/%2C/g, ',');
      window.applyAltOrderSearchConstraint(params, '');
      const nextParams = params.toString().replace(/%2C/g, ',');
      if (currentParams === nextParams) return;
      Facets.filterData = [];
      Facets.renderPage(nextParams);
      return;
    }

    const current = (params.get('filter.p.tag') || '')
                      .split(',')
                      .filter(Boolean);
  
    // Get all possible alt-order tags from all modes
    const allAltOrderTags = Object.values(MODES_CONFIG).flatMap(config => config.tags);
    
    if (!current.some(tag => allAltOrderTags.includes(tag))) return; // No alt-order tags to remove
  
    Facets.filterData = [];   // flush cache only if really something changes
  
    const remaining = current.filter(tag => !allAltOrderTags.includes(tag));
    remaining.length
      ? params.set('filter.p.tag', remaining.join(','))
      : params.delete('filter.p.tag');
  
    Facets.renderPage(params.toString().replace(/%2C/g, ','));
  }

  /* ---------- CLEAN AND APPLY alt-order tags ---------- */
  async function cleanAndApplyAltOrderTags() {
    const config = MODES_CONFIG[cartMode];
    const settings = window.altOrderSettings || {};
    const Facets = await getFacetsClass();
    
    const params = new URLSearchParams(window.location.search);

    if (
      window.location.pathname.includes('/search') &&
      typeof window.applyAltOrderSearchConstraint === 'function'
    ) {
      const currentParams = params.toString().replace(/%2C/g, ',');
      window.applyAltOrderSearchConstraint(params, cartMode);
      const nextParams = params.toString().replace(/%2C/g, ',');
      if (currentParams === nextParams) return;
      Facets.filterData = [];
      Facets.renderPage(nextParams);
      return;
    }

    const current = (params.get('filter.p.tag') || '')
                      .split(',')
                      .filter(Boolean);
    
    // Get all possible alt-order tags from all modes
    const allAltOrderTags = Object.values(MODES_CONFIG).flatMap(config => config.tags);
    
    // Remove all alt-order tags first
    const cleanedTags = current.filter(tag => !allAltOrderTags.includes(tag));
    
    let finalTags = cleanedTags;
    
    // Add new tags only if filtering is enabled for current mode
    if (config) {
      const shouldFilterTags = (cartMode === 'preorder' && settings.preorderOnlyWithTag) || 
                              (cartMode === 'exChina' && settings.exChinaOnlyWithTag);
      
      if (shouldFilterTags) {
        finalTags = cleanedTags.concat(config.tags);
      }
    }
    
    // Check if we need to update
    const currentTagsString = current.sort().join(',');
    const finalTagsString = finalTags.sort().join(',');
    
    if (currentTagsString === finalTagsString) return; // No changes needed
    
    Facets.filterData = []; // flush cache only if changed
    
    // Update the URL with the final tags in a single operation
    if (finalTags.length) {
      params.set('filter.p.tag', finalTags.join(','));
    } else {
      params.delete('filter.p.tag');
    }
    
    Facets.renderPage(params.toString().replace(/%2C/g, ','));
  }

  /* ---------- FIRST VISIT ALERT ---------- */
  function showFirstVisitAlert() {
    
    // Check if there's an active alt-order mode
    if (!cartMode) return; // No active mode, don't show alert
    if (cartMode === 'visitor') return; // Don't show alert for visitor
    
    // Check if this is the first visit in the session
    const sessionKey = 'altOrderAlertShown';
    const alertShown = sessionStorage.getItem(sessionKey);
    
    if (alertShown) return; // Alert already shown in this session
    
    // Get the mode configuration from global MODES_CONFIG
    const config = MODES_CONFIG[cartMode];
    if (!config) return;
    
    // Use the mode name from config
    const modeName = config.name.toUpperCase();
    
    // Show the alert
    const $alert = $('#alt-order-alert');
    const $modeSpan = $('#alt-order-alert-mode');
    
    if ($alert.length && $modeSpan.length) {
      $modeSpan.text(modeName);
      $alert.slideDown(300);
      
      // Mark as shown in this session
      sessionStorage.setItem(sessionKey, 'true');
      
      // Auto-close after 10 seconds
      setTimeout(function() {
        $alert.slideUp(300);
      }, 7000);
    }
    
    // Set up event listeners for the alert buttons
    setupAlertHandlers();
  }
  
  function setupAlertHandlers() {
    // Handler for "Switch to regular order" button
    $('#switch-to-normal').off('click').on('click', function() {
      // Switch to normal mode
      $('input[name="cart-mode"][value=""]').prop('checked', true).trigger('change');
      
      // Hide the alert
      $('#alt-order-alert').slideUp(300);
    });
    
    // Handler for close button (X)
    $('#close-alt-alert').off('click').on('click', function() {
      $('#alt-order-alert').slideUp(300);
    });
  }
